<!--
 * @Author: Shber
 * @Date: 2022-03-08 16:49:02
 * @LastEditors: Shber
 * @LastEditTime: 2023-06-14 17:01:12
 * @Description:
-->
<template>
  <p v-if="isText" class="error_text">
    <Icon name="clear" class="mr_5" />
    {{ isText }}
  </p>

</template>
<script setup>
import { computed, defineProps } from 'vue'
import { Icon } from 'vant'
const props = defineProps({
  text: {
    type: String,
    default: ''
  }
})

const isText = computed(() => props.text)

</script>
